import Block from './Block'
import App from '../App'
import { throttle } from 'throttle-debounce'
import gsap from 'gsap'
import { browser } from '../util/browserInfo'

export default class AlbumPreview extends Block {
  onEnterCompleted() {
    this.isBig = this.el.classList.contains('big')

    this.props = {
      circleSize: this.isBig ? 150 : 40,
      titleHeight: this.title.offsetHeight,
      titleWidth: this.title.offsetWidth,
      currentHeight: 0,
      currentPos: {
        x: 0,
        y: 0
      }
    }
  }

  getElems() {
    this.title = this.el.querySelector('.album-preview__title')
    this.cursor = this.el.querySelector('.album-preview__cursor')
  }

  bindMethods() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onMouseMoveThrottle = browser.name === 'Firefox' ? this.onMouseMove : throttle(50, this.onMouseMove)
  }

  events() {
    this.title.addEventListener('mousemove', this.onMouseMoveThrottle)
    this.title.addEventListener('mouseenter', this.onMouseEnter)
    this.title.addEventListener('mouseleave', this.onMouseLeave)
  }

  destroy() {
    this.title.removeEventListener('mousemove', this.onMouseMoveThrottle)
    this.title.removeEventListener('mouseenter', this.onMouseEnter)
    this.title.removeEventListener('mouseleave', this.onMouseLeave)
  }

  clamp(val, min, max) {
    return Math.max(min, Math.min(max, val))
  }

  onMouseEnter(e) {
    if (!this.props.titleHeight) return

    App.cursor.scaleTo(this.props.circleSize * 2)
    App.cursor.removeBorders()
    App.cursor.disableBackground()

    this.props.currentPos = {
      x: this.isBig ? e.offsetX : this.clamp(e.offsetX, this.props.circleSize, this.props.titleWidth - this.props.circleSize),
      y: this.clamp(e.offsetY, this.props.circleSize, this.props.titleHeight - this.props.circleSize)
    }

    gsap.set(this.cursor, {
      clipPath: 'circle(' + this.props.currentHeight + 'px at ' + this.props.currentPos.x + 'px ' + this.props.currentPos.y + 'px)'
    })

    this.props.currentHeight = this.props.circleSize

    gsap.to(this.cursor, {
      alpha: 1,
      clipPath: 'circle(' + this.props.currentHeight + 'px at ' + this.props.currentPos.x + 'px ' + this.props.currentPos.y + 'px)',
      duration: 0.8,
      ease: 'power3.out'
    })
  }

  onMouseMove(e) {
    if (!this.props.titleHeight) return

    this.props.currentPos = {
      x: this.isBig ? e.offsetX : this.clamp(e.offsetX, this.props.circleSize, this.props.titleWidth - this.props.circleSize),
      y: this.clamp(e.offsetY, this.props.circleSize, this.props.titleHeight - this.props.circleSize)
    }

    gsap.to(this.cursor, {
      clipPath: 'circle(' + this.props.currentHeight + 'px at ' + this.props.currentPos.x + 'px ' + this.props.currentPos.y + 'px)',
      duration: this.isBig ? 1.2 : 0.8,
      ease: 'power3.out'
    })
  }

  onMouseLeave() {
    this.props.currentHeight = 0

    App.cursor.resetScale()
    App.cursor.resetBorders()
    App.cursor.resetBackground()

    gsap.to(this.cursor, {
      clipPath: 'circle(' + this.props.currentHeight + 'px at ' + this.props.currentPos.x + 'px ' + this.props.currentPos.y + 'px)',
      alpha: 0,
      duration: 0.8,
      ease: 'power3.out'
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/AlbumPreview.js